<div class="xp-stat__label">{{ label() }}</div>
<div class="xp-stat__top">
	<div class="xp-stat__value">{{ value() }}<ng-content select="[xpStatValue]"></ng-content></div>
	<ng-content select="[xpStatAside]"></ng-content>
</div>
<ng-content></ng-content>
